<template>
  <div class="store-container">
    <h5>
      {{ "store_checkout.your_order" | translate }}
      {{ `store.${order.store.storeName}` | translate }}
    </h5>
    <div class="horizontal-line"></div>
    <div class="flex">
      <div class="image-container">
        <div
          :style="{
            backgroundImage: `url(${require(`../../assets/images/stores/lumi_accessories.jpg`)})`
          }"
        ></div>
      </div>
      <div class="store-details">
        <div class="flex">
          <span>{{ "store_checkout.order_value" | translate }}:</span>
          <span>CHF {{ sumProductPrice(order.product_confirmations) }}.-</span>
        </div>
        <div class="flex">
          <span>{{ "store_checkout.shipping_cost" | translate }}:</span>
          <span>CHF xx.-</span>
        </div>
        <div class="flex total">
          <span>{{ "store_checkout.total" | translate }}:</span>
          <span>
            CHF {{ totalWithShipping(order.product_confirmations) }}.-
          </span>
        </div>
        <div>
          <div class="flex">
            <span>{{ "store_checkout.view_products" | translate }}</span>
            <i
              v-if="!productsVisible"
              class="material-icons"
              @click="showProducts"
              >add</i
            >
            <i
              v-if="productsVisible"
              class="material-icons"
              @click="showProducts"
              >remove</i
            >
          </div>
          <div
            class="product-list-container"
            :class="{ visible: productsVisible }"
          >
            <div
              v-for="order_product in order.products"
              :key="order_product.id"
              class="product-listing"
            >
              <div
                class="product-image"
                :style="{
                  backgroundImage: `url(${getProductImageLowRes(
                    order_product.imageSources[0],
                    order_product.store
                  )})`
                }"
              ></div>
              <div class="flex-col">
                <span>{{ order_product.name }}</span>
                <span>CHF {{ order_product.priceOriginal }}.-</span>
              </div>
            </div>
          </div>
          <button
            class="salmon button"
            @click="handleStripeSubmitForStore"
            type="button"
          >
            {{ "store_checkout.confirm" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { productImageResizer } from "../../mixins";
import { addPaymentMethod } from "../../services/api";

export default {
  name: "store-checkout",
  mixins: [productImageResizer],
  props: {
    input: {},
    card: null,
    stripeSecret: null,
    stripeSetup: null,
    platformStripeSetup: null,
    store: null,
    order: null
  },
  data() {
    return {
      productsVisible: false
    };
  },
  methods: {
    showProducts() {
      this.productsVisible = !this.productsVisible;
    },
    sumProductPrice(products) {
      return products.reduce((prev, curr) => (prev += curr.price), 0);
    },
    totalWithShipping(products) {
      const productTotal = products.reduce(
        (prev, curr) => (prev += curr.price),
        0
      );
      //TODO: add shipping to final value
      return productTotal;
    },
    sumProductCounts(products) {
      return products.reduce((prev, curr) => (prev += curr.count), 0);
    },
    async handleStripeSubmitForStore(event) {
      event.preventDefault();
      const { card } = this;
      const { paymentIntentSecret, connectId } = this.stripeSecret;
      const paymentMethodResult = await this.platformStripeSetup.createPaymentMethod(
        {
          type: "card",
          card,
          billing_details: {
            name: this.input.card_holder,
            email: this.input.email,
            address: {
              line1: this.input.address1,
              line2: this.input.address2,
              postal_code: this.input.postal_code,
              city: this.input.city
            }
          }
        },
        { stripeAccount: connectId }
      );
      const { order_id, store_id } = this.order;
      const { paymentMethod } = paymentMethodResult;
      const added = await addPaymentMethod(
        order_id,
        store_id,
        paymentMethod.id
      );
      if (added.status !== 201) {
        // console.log("Couldn't add payment method");
        return;
      }
      // console.log("Payment method added");
      const stripeOptions = {};
      if (this.input.save_card) {
        stripeOptions["setup_future_usage"] = "off_session";
      }
      const stripeSetup = this.stripeSetup;
      const result = await stripeSetup.confirmCardPayment(
        paymentIntentSecret,
        stripeOptions
      );

      if (result.error) {
        // Show error to your customer (e.g., insufficient funds)
        //console.log(result.error.message);
      } else {
        // The payment has been processed!
        if (result.paymentIntent.status === "requires_capture") {
          // console.log("Success in payment!");
          // Show a success message to your customer
          // There's a risk of the customer closing the window before callback
          // execution. Set up a webhook or plugin to listen for the
          // payment_intent.succeeded event that handles any business critical
          // post-payment actions.
        }
      }
    }
  },
  mounted() {
    const detailsHeight = $(".store-details").height();
    $(".image-container").height(detailsHeight);
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.store-container {
  background-color: $brand-white;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;

  @media (min-width: $breakpoint-lg) {
    margin-bottom: 0;
  }
}

.horizontal-line {
  height: 2px;
  background-color: $brand-black;
  margin-bottom: 2rem;
}

.image-container {
  width: 45%;
  padding-right: 1.5rem;
  display: none;

  div {
    height: 100%;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }

  @media (min-width: $breakpoint-lg) {
    display: initial;
  }
}

.store-details {
  width: 100%;
  @media (min-width: $breakpoint-lg) {
    width: 55%;
  }

  .flex {
    justify-content: space-between;
    margin-bottom: 1rem;

    span {
      font-size: $font-sm;
    }

    &.total {
      span {
        font-size: $font-base;
        font-weight: 600;
      }
    }
  }
}

.button.salmon {
  box-shadow: none;
  width: 100%;
  font-size: $font-sm;
}

.product-list-container {
  max-height: 0;
  overflow: hidden;
  transition: all 0.4s ease-in-out;

  &.visible {
    max-height: 40rem;
  }
}

.product-listing {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;

  .product-image {
    width: 4rem;
    height: 5.4rem;
    min-width: 4rem;
    background-color: $brand-gray-light;
    margin-right: 1rem;
    background-size: cover;
  }

  .flex-col {
    justify-content: space-between;
    width: 100%;
  }
}
</style>
